import { Component, Inject, ViewChild, ElementRef, Renderer2, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/platform-browser";
import { Title } from '@angular/platform-browser';
import { routes, AppRoutes } from './app.routing';
import { NotificationService } from "./services/notification.service";
import { SlideNotifier } from './models/slideNotifier.model';

declare var require: any
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  @ViewChild("searchInput") searchInput: ElementRef;
  @ViewChild("dedoContent") dedoContent: ElementRef;
  public appRoutes;
  public toggle: boolean;
  public toggleSearch: boolean;
  title = 'app';
  public logo = require('../assets/images/private/logo.png');
  public ourwedding = require('../assets/images/animations/ourwedding_wh.gif');
  public slideNotifier: SlideNotifier;

  public photo = require('../assets/images/private/wedding-shots/44.jpg');
  public imgData: string = this.photo;
  private t1 = 0;
  constructor(@Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private router: Router,
    titleService: Title,
    private notificationService: NotificationService,
    private renderer: Renderer2) {

    this.slideNotifier = new SlideNotifier(
      this.imgData,
      '../assets/images/animations/ourwedding_wh.gif',
      "Kéo xuống"
    );
    this.appRoutes = new AppRoutes().Navs;

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        var title = this.getTitle(router.routerState, router.routerState.root).join(' ');
        titleService.setTitle(title);
      }
    });

    // body subscription
    this.notificationService.BodyNotifyObservable$.subscribe((res) => {
      if (res) {
        this.renderer.addClass(this.document.documentElement, "slide-shown");
        this.renderer.addClass(this.document.body, "mfp-zoom-out-cur");
        this.renderer.addClass(this.dedoContent.nativeElement, "slide-shown");
      }
      else {
        this.renderer.removeClass(this.document.documentElement, "slide-shown");
        this.renderer.removeClass(this.document.body, "mfp-zoom-out-cur");
        this.renderer.removeClass(this.dedoContent.nativeElement, "slide-shown");
      }
    });

    // slide subscription
    this.notificationService.SlideNotifyObservable$.subscribe((res) => {
      this.slideNotifier = res;
    });
  }

  private getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push.apply(data, this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  toggleMenu() {
    this.toggle = !this.toggle;
  }

  displaySearchDropdown() {
    this.toggleSearch = true;
    this.searchInput.nativeElement.focus();
  }

  hideSearchDropdown() {
    this.toggleSearch = false;
  }

  toTop(event, first = false) {
    if (first) {
      event.preventDefault();
    }
    let y1 = window.scrollY;
    y1 = y1 - 1000;
    window.scrollTo(0, y1);
    if (y1 > 0) {
      this.t1 = setTimeout(this.toTop(event), 100);
    } else {
      clearTimeout(this.t1);
    }
  }

  scrollDown(event, el) {
    event.preventDefault();
    el.scrollIntoView();
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts